/*
import type {
  DynamicLabelExtra,
  DynamicLabels,
} from 'src/action-creators/dynamic-labels';
*/
import type {DynamicLabelExtra, DynamicLabels, AtsDynamicLabel} from './types';

import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import capitalize from 'lodash/capitalize';
import chunk from 'lodash/chunk';
import {
  entityColorMapping,
  generateAttributeGrammarTokens,
} from 'src/utils/entities';
import classify from 'src/utils/classify';

import TruncatedText from 'src/components/lib/truncated-text';

import common from 'src/styles/common.css';
import css from './variable-picker.css';


export type VariablePickerModalRowProps = {
  data: {
    labels: DynamicLabels;
    selectedIndex: number;
    onClick: (
      arg1: DynamicLabelExtra,
      evt: React.MouseEvent<HTMLDivElement>,
    ) => void;
  };
  index: number;
  style: Record<any, any>;
};

const VariablePickerModalRow = ({
  data: {labels, selectedIndex, onClick},
  index,
  style,
}: VariablePickerModalRowProps): React.ReactElement<
  React.ComponentProps<'div'>
> => {
  const dynamicLabel = labels[index];
  const {t} = useLabelTranslation();

  const color =
    // @ts-expect-error - TS2339 - Property 'sense_name' does not exist on type 'DynamicLabelExtra'.
    (dynamicLabel.sense_name &&
      // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly internal_employee: { readonly name: "purple"; readonly text: "colorPurpleShadow"; readonly background: "colorPurpleTint"; }; readonly ab_web_applicant: { readonly name: "purple"; readonly text: "colorPurpleShadow"; readonly background: "colorPurpleTint"; }; ... 24 more ...; readonly job_match_variable: { ...'. | TS2339 - Property 'sense_name' does not exist on type 'DynamicLabelExtra'.
      common[entityColorMapping[dynamicLabel.sense_name]?.text]) ||
    common.colorGray6;

  return (
    <div
      // even/odd in JS because react-window will
      // make css order unpredictable
      className={classify(
        index % 2 === 0 ? css.resultEven : css.resultOdd,
        selectedIndex === index ? css.resultSelected : '',
      )}
      onClick={(evt) => {
        onClick(dynamicLabel, evt);
      }}
      style={style}
    >
      <div className={css.label}>
        <TruncatedText
          className={css.modalVariableName}
          style={{
            color,
          }}
          text={
            dynamicLabel.source === 'custom'
              ? dynamicLabel.name
              : dynamicLabel.entityRelationshipPath[0]
          }
          limit={60}
          component="h3"
        />
        <div className={css.grammarTokens}>
          {dynamicLabel.source === 'custom' ? (
            <p>{t(dynamicLabel.description, dynamicLabel.description)}</p>
          ) : (
            <GrammarTokens dynamicLabel={dynamicLabel} />
          )}
        </div>
      </div>
      <div className={css.labelType}>
        {capitalize(
          dynamicLabel.source === 'custom'
            ? t(dynamicLabel.category, dynamicLabel.category)
            : t(
                dynamicLabel.mapping.display_name,
                dynamicLabel.mapping.display_name,
              ),
        )}
      </div>
    </div>
  );
};

export default VariablePickerModalRow;

function GrammarTokens({dynamicLabel}: {dynamicLabel: AtsDynamicLabel}) {
  const {t} = useLabelTranslation();
  return chunk(
    generateAttributeGrammarTokens(dynamicLabel.entityRelationshipPath),
    2,
    // @ts-expect-error - TS2345 - Argument of type '([prefix, token]: [any, any]) => React.JSX.Element' is not assignable to parameter of type '(value: string[], index: number, array: string[][]) => Element'.
  ).map(([prefix, token]: [any, any]) => (
    <p key={`${dynamicLabel.value}${t(prefix, prefix)}${token}`}>
      {`${t(prefix, prefix)} `}
      <TruncatedText
        className={css.token}
        text={token}
        limit={60}
        component="span"
      />
    </p>
  ));
}
